import { render } from "./UsernameBadge.vue?vue&type=template&id=56717e93&scoped=true"
import script from "./UsernameBadge.vue?vue&type=script&lang=js"
export * from "./UsernameBadge.vue?vue&type=script&lang=js"

import "./UsernameBadge.vue?vue&type=style&index=0&id=56717e93&lang=scss&scoped=true"

import exportComponent from "../../../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56717e93"],['__file',"src/components/app/nav/UsernameBadge.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "56717e93"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('56717e93', __exports__)) {
    api.reload('56717e93', __exports__)
  }
  
  module.hot.accept("./UsernameBadge.vue?vue&type=template&id=56717e93&scoped=true", () => {
    api.rerender('56717e93', render)
  })

}


export default __exports__